/**
 * Generate a device fingerprint for trusted device registration.
 * Uses browser properties that are stable across sessions.
 */
export async function getDeviceFingerprint(): Promise<string> {
  const s = window.screen;
  const raw = [
    navigator.userAgent,
    `${s.width}x${s.height}`,
    Intl.DateTimeFormat().resolvedOptions().timeZone,
    navigator.language,
  ].join('|');

  // SHA-256 hash
  const encoder = new TextEncoder();
  const data = encoder.encode(raw);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
}
